import './Layers.scss';
import { Button } from 'primereact/button';
import { ContextMenu } from 'primereact/contextmenu';
import { Tree } from 'primereact/tree';
import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectServices, setServices, setTableLayer, setLayerGroups, setLayerNodes } from '../../features/layerSlice';
import { Dialog } from 'primereact/dialog';
import { RadioButton } from 'primereact/radiobutton';
import { setSelectedRow, setShowLoading } from '../../features/sharedSlice';
import { saveAs } from 'file-saver';
import { setImportedFileVisibility } from '../../features/importSlice';
import axios from 'axios';

enum ExportTypes {
    'KML' = 0,
    'SHAPEFILE' = 1
}

interface Props {
    zindex?: boolean
}


export default function Layers(props: Props) {
    const cm: any = useRef(null);
    const cm2: any = useRef(null);
    const cm3: any = useRef(null);
    const [layersOpened, setLayersOpened] = useState(true)
    const [exportOpened, setExportOpened] = useState(false)
    const [isVectorLayer, setIsVectorLayer] = useState(false)
    const [opacityTimeout, setOpacityTimeout] = useState<any>();
    const [exportType, setExportType] = useState(ExportTypes.KML)
    const [nodes, setNodes] = useState<any>([])
    const [selectedKey, setSelectedKey] = useState<any>(null);
    const [selectedInternalLayer, setSelectedInternalLayer] = useState<any>(null);
    const globalServices = useAppSelector(selectServices);
    const token = useAppSelector(state => state.authState.token);
    const importLayerGroup: any = useAppSelector(state => state.layer.importLayerGroup);
    const dispatch = useAppDispatch();
    const functionalRoles = useAppSelector(state => state.sharedState.functionalRoles);
    const activeLanguage = useAppSelector(state => state.language.activeLanguage);
    const zindex = props.zindex;
    const selectedFeature = useAppSelector(state => state.selectionState.selectedFeature);
    const selectedRow = useAppSelector(state => state.sharedState.tableRow);
    const dataRoles = useAppSelector(state => state.sharedState.dataRoles);
    
    let menu1: any = [
        {
            label: 'Dışa Aktar',
            icon: 'pi pi-external-link',
            command: () => {
                setExportOpened(true);
            }
        }
    ]
    let menu2: any = [
        isVectorLayer && selectedInternalLayer.permission !== 1 ? {
            label: 'Tabloyu Aç',
            icon: 'pi pi-table',
            command: () => {
                if (selectedInternalLayer) {
                    dispatch(setTableLayer(selectedInternalLayer));
                }
            }
        } : {
            className: 'hidden-context-menu'
        }
    ]
    let menu3: any = [
        {
            label: 'Dışa Aktar',
            icon: 'pi pi-external-link',
            command: () => {
                setExportOpened(true);
            }
        },
        isVectorLayer && selectedInternalLayer.permission !== 1 ? {
            label: 'Tabloyu Aç',
            icon: 'pi pi-table',
            command: () => {
                if (selectedInternalLayer) {
                    dispatch(setTableLayer(selectedInternalLayer));
                }
            }
        } : {
            className: 'hidden-context-menu'
        }
    ]

    useEffect(() => {
        if (token && !window.location.href.includes('sb-atlas')) {
            setTimeout(() => {
                setPrivateLayers();
            }, 100);
        }
        if (window.location.href.includes('sb-atlas')) {
            setTimeout(() => {
                setPrivateLayers();
            }, 100);
        }
    }, [activeLanguage, token, functionalRoles, dataRoles]);

    useEffect(() => {
        if (importLayerGroup) {
            const isCevrimdisiCreated = nodes.some((node: any) => node.label === 'Çevrimdışı')
            const newNodeArray = [...nodes, importLayerGroup]
            if (isCevrimdisiCreated) {
                //çevrimdışıları birden fazla ise tek bir başlık altına topla
                const cevrimdisilar = newNodeArray.filter((node: any) => node.label === 'Çevrimdışı');
                const other = newNodeArray.filter((node: any) => node.label !== 'Çevrimdışı');
                const childrenArr: any = []
                cevrimdisilar.map((cevrimdisi: any) => {
                    childrenArr.push(...cevrimdisi.children)
                })
                const offlineLayerGroup = {
                    key: 'cevrimdisi',
                    label: "Çevrimdışı",
                    children: childrenArr,
                }
                setNodes([...other, offlineLayerGroup]);
                dispatch(setLayerNodes([...other, offlineLayerGroup]));
            }
            else {
                setNodes(newNodeArray);
                dispatch(setLayerNodes([...nodes, importLayerGroup]));

            }
        }
    }, [importLayerGroup])

    useEffect(() => {
        if (selectedFeature && selectedFeature.id && selectedRow) {
            const layerName = selectedFeature.id.split('.')[0];
            
            switch (layerName) {
                case 'osb_sinir_usr':
                    setSelectedKey({
                        ...selectedKey, ... {
                            "2": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "2-3385": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'ebler_usr':
                    setSelectedKey({
                        ...selectedKey, ... {
                            "2": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "2-3643": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'tgb_usr':
                    setSelectedKey({
                        ...selectedKey, ... {
                            "79": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "79-3671": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'parsel_usr':
                    setSelectedKey({
                        ...selectedKey, ... {
                            "72": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "72-3380": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'parsel_pasif_usr':

                    setSelectedKey({
                        ...selectedKey, ... {
                            "72": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "72-10842": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'cografi_bolge_usr':

                    setSelectedKey({
                        ...selectedKey, ... {
                            "69": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "69-4918": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'istatistik_bolge_duzey_2_usr':
                    setSelectedKey({
                        ...selectedKey, ... {
                            "69": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "69-4994": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'tesvik_bolgeleri_usr':
                    setSelectedKey({
                        ...selectedKey, ... {
                            "69": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "69-4986": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'il_usr':

                    setSelectedKey({
                        ...selectedKey, ... {
                            "66": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "66-3427": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'ilce_usr':

                    setSelectedKey({
                        ...selectedKey, ... {
                            "66": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "66-4910": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'karayolu_usr':

                    setSelectedKey({
                        ...selectedKey, ... {
                            "63": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "63-3592": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'demiryolu_usr':

                    setSelectedKey({
                        ...selectedKey, ... {
                            "63": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "63-3598": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'havalimani_usr':

                    setSelectedKey({
                        ...selectedKey, ...{
                            "63": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "63-3616": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'liman_usr':

                    setSelectedKey({
                        ...selectedKey, ... {
                            "63": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "63-3622": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'tgb_uip_1000':
                    setSelectedKey({
                        ...selectedKey, ... {
                            "64": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "64-10908": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'eb_uip_1000':

                    setSelectedKey({
                        ...selectedKey, ... {
                            "64": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "64-10903": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;
                case 'uip_1000':
                    setSelectedKey({
                        ...selectedKey, ... {
                            "64": {
                                "checked": false,
                                "partialChecked": true
                            },
                            "64-8384": {
                                "checked": true,
                                "partialChecked": false
                            }
                        }
                    })
                    break;

                default:
                    break;
            }
            dispatch(setSelectedRow(false))
        }

    }, [selectedFeature, selectedRow])

    const setPrivateLayers = async () => {
        const access_token = token ? `?token=${token}` : ''
        const classes = document.createElement('style');
        classes.innerHTML = ``;
        const stylesResponse = await axios(process.env.REACT_APP_BASE_URL + 'rest/v1/style' + access_token)
        const servicesResponse = await axios(process.env.REACT_APP_BASE_URL + 'rest/v1/services' + access_token)
        const layerGroupResponse = await axios(process.env.REACT_APP_BASE_URL + 'rest/v1/layerGroup' + access_token)        

        const tree = []
        const services = servicesResponse.data.services.services;

        if (globalServices) {
            for (const service of services) {
                const globalService: any = globalServices.find(obj => obj.name === service.name)
                for (const layer of service.layers) {
                    layer.opacity = 1;
                    if (layer.name === 'parsel_usr'
                        || layer.name === 'osb_sinir_usr'
                        // || layer.name === 'tgb_usr'
                        || layer.name === 'ebler_usr'
                        || layer.name === 'parsel_pasif_usr'
                    ) {
                        layer.visible = true;
                    }
                    if (globalService) {
                        const globalLayer = globalService.layers.find((obj: any) => obj.name === layer.name)
                        if (globalLayer) {
                            layer.visible = globalLayer.visible;
                        }
                    }
                }
            }
        } else {
            for (const service of services) {
                for (const layer of service.layers) {
                    layer.opacity = 1;
                }
            }
        }
        const styles = stylesResponse.data.styles;
        //vatandas ekranında filtreleme
        const layerGroups = !token ?
            layerGroupResponse.data.layerGroups.filter((layerGroup: any) => layerGroup.name !== 'ortofoto' && layerGroup.name !== 'tkgm' && layerGroup.name !== 'meb' )
            : layerGroupResponse.data.layerGroups.filter((layerGroup: any) => layerGroup.name !== 'default_group' )
        // if ((window.location.pathname.split('/')[1] === 'vatandas')) {
        // }
        const check: any = []
        layerGroups.sort((a: any, b: any) => a.priority > b.priority ? 1 : -1);
        for (const layerGroup of layerGroups) {
            const filteredLayers = layerGroup.layers.filter((obj: any) => obj.name !== 'panogps_usr' && obj.name !== 'kucuk_sanayi_usr' && obj.name !== 'osb_onayli_sinir_usr' )
            if (filteredLayers.length > 0) {
                const serviceAlias = activeLanguage === 'tr' ? layerGroup.alias : layerGroup.alias_eng;
                const children = []
                filteredLayers.sort((a: any, b: any) => a.priority < b.priority ? 1 : -1)
                for (const layer of filteredLayers) {
                    const layerAlias = activeLanguage === 'tr' ? layer.alias : layer.alias_eng;
                    layer.opacity = 0.8;
                    layer.labeling = 0;

                    const allPerm = dataRoles.filter((role: any) => role.layer_id === layer.id);
                    const maxPermission = Math.max(...allPerm.map((o: any) => o.permission))
                    layer.permission = maxPermission;

                    const style = styles.find((obj: any) => obj.id === layer.style_id);

                    const child = {
                        key: layerGroup.id + '-' + layer.id,
                        label: layerAlias,
                        data: layer,
                        icon: `iconforsidebar_${layer.name}`,
                        iconData: '',
                    }

                    if (style) {
                        switch (style.type) {
                            case 'point':
                                if (style.icon) {
                                    child['iconData'] = `data:image/${style.icon}`;
                                    classes.innerHTML += `\n.iconforsidebar_${layer.name} { background-image: url(data:image/${style.icon}) }`
                                }
                                break;
                            case 'linestring':
                                const lineCanvas = document.createElement('canvas');
                                lineCanvas.width = 20
                                lineCanvas.height = 20
                                const ctx = lineCanvas.getContext('2d')!;
                                ctx.moveTo(0, 10);
                                ctx.lineTo(20, 10);
                                ctx.lineWidth = style.stroke_width;
                                ctx.strokeStyle = style.stroke_color;
                                ctx.stroke();
                                const dataURL = lineCanvas.toDataURL();
                                const classString = `\n.iconforsidebar_${layer.name} { background-image: url(${dataURL}) }`
                                child['iconData'] = dataURL;
                                classes.innerHTML += ` ${classString}`
                                break;
                            case 'polygon':
                                const polygonCanvas = document.createElement('canvas');
                                polygonCanvas.width = 20
                                polygonCanvas.height = 20
                                const polygonCtx = polygonCanvas.getContext('2d')!;
                                polygonCtx.fillStyle = style.fill_color;
                                polygonCtx.strokeStyle = style.stroke_color;
                                polygonCtx.lineWidth = style.stroke_width;
                                polygonCtx.beginPath();
                                polygonCtx.moveTo(0, 0);
                                polygonCtx.lineTo(20, 0);
                                polygonCtx.lineTo(20, 20);
                                polygonCtx.lineTo(0, 20);
                                polygonCtx.closePath();
                                polygonCtx.fill();
                                polygonCtx.stroke();
                                const dataURLPolygon = polygonCanvas.toDataURL();
                                const classStringPolygon = `\n.iconforsidebar_${layer.name} { background-image: url(${dataURLPolygon}) }`
                                classes.innerHTML += ` ${classStringPolygon}`
                                child.iconData = dataURLPolygon;
                                break;
                            default:
                                break;
                        }
                    }
                    children.push(child);
                }

                const serviceNode = {
                    key: layerGroup.id,
                    label: serviceAlias,
                    data: null,
                    children
                }
                tree.push(serviceNode);
            }
        }
        const vectorService = services.find((obj: any) => obj.type === 'VECTOR')?.url
        // const role = functionalRoles.findIndex((role: any) => role.function_id === 21) > -1
        // if (role) {
        if (vectorService) {
            const tematikService = {
                "id": 999,
                "name": "tematik",
                "alias": "Tematik Haritalar",
                "url": vectorService,
                "type": "TEMATIK",
                "workspace": "osb",
                "isactive": true,
                "layers": [
                    {
                        "id": 10000,
                        "name": "cografi_bolgelere_gore_osb",
                        "service_id": 999,
                        "opacity": 0.8,
                        "visible": false
                    },
                    {
                        "id": 10001,
                        "name": "c_bolgelere_gore_istihdam",
                        "service_id": 999,
                        "opacity": 0.8,
                        "visible": false
                    },
                    {
                        "id": 10002,
                        "name": "t_bolgelere_gore_osb",
                        "service_id": 999,
                        "opacity": 0.8,
                        "visible": false
                    },
                    {
                        "id": 10003,
                        "name": "t_bolgelere_gore_istihdam",
                        "service_id": 999,
                        "opacity": 0.8,
                        "visible": false
                    },
                    {
                        "id": 10004,
                        "name": "ibbs2_bolgelere_gore_osb",
                        "service_id": 999,
                        "opacity": 0.8,
                        "visible": false
                    },
                    {
                        "id": 10005,
                        "name": "ibbs2_bolgelere_gore_istihdam",
                        "service_id": 999,
                        "opacity": 0.8,
                        "visible": false
                    },
                    {
                        "id": 10006,
                        "name": "illere_gore_osb",
                        "service_id": 999,
                        "opacity": 0.8,
                        "visible": false
                    },
                    {
                        "id": 10007,
                        "name": "illere_gore_istihdam",
                        "service_id": 999,
                        "opacity": 0.8,
                        "visible": false
                    }
                ]
            }
            services.push(tematikService)
        } else {
            console.error('Tematik haritalar icin service bulunamadi.');
        }
        //parsel ve osb açık gelsin diye burayı dinamik yapmak lazım

        setSelectedKey({
            "2": {
                "checked": true,
                "partialChecked": false
            },
            "72": {
                "checked": true,
                "partialChecked": false
            },
            "2-3385": {
                "checked": true,
                "partialChecked": false
            },
            "2-3643": {
                "checked": true,
                "partialChecked": false
            },
            "72-3380": {
                "checked": true,
                "partialChecked": false
            },
            "72-10842": {
                "checked": true,
                "partialChecked": false
            },
            
        })

        dispatch(setServices(services));
        dispatch(setLayerGroups(layerGroups))
        document.getElementsByTagName('head')[0].appendChild(classes);

        if (token) {
            const tematikHaritalar = getTematikHaritalar()
            tree.push(tematikHaritalar);
        }
        // }

        dispatch(setLayerNodes(tree));
        setNodes(tree)



    }
    
    useEffect(() => {
        const cloneServices = []
        for (const service of globalServices) {
            const cloneService = { ...service, layers: [] }
            const cloneLayers = []
            for (const layer of service.layers) {
                const cloneLayer = { ...layer, visible: false }
                cloneLayers.push(cloneLayer);
            }
            
            (cloneService as any).layers = cloneLayers;
            cloneServices.push(cloneService);
        }
        if (selectedKey) {
            const keys = Object.keys(selectedKey).filter(key => key.includes('-'))
            const cevrimdisiKeys = Object.keys(selectedKey).filter(key => key.includes('cevrimdisi'))
            for (const key of keys) {
                if (!importLayerGroup || (importLayerGroup && key !== importLayerGroup.key)) {
                    const layer_id = key.split('-')[1]
                    const layers = cloneServices.map(service => service.layers).flat();
                    
                    const layer: any = layers.find((obj: any) => obj.id === parseInt(layer_id));
                    if (layer) {
                        const theLayer: any = cloneServices.find(service => service.id === layer.service_id)?.layers.find((obj: any) => obj.id === layer.id)
                        if (theLayer) {
                            theLayer.visible = true;
                        }
                    }
                }
            }
            if (cevrimdisiKeys.length > 0) {
                for (const key of cevrimdisiKeys) {
                    if (key) {
                        dispatch(setImportedFileVisibility(true))
                    }
                    else {
                        dispatch(setImportedFileVisibility(false))
                    }
                }
            }
            else {
                dispatch(setImportedFileVisibility(false))
            }

        }
        dispatch(setServices(cloneServices));
    }, [selectedKey])


    const getTematikHaritalar = () => {


        const tematikHaritalar = {
            children: [
                {
                    "key": "9999-10000",
                    "label": "Coğrafi Bölgelere Göre OSB Sayıları",
                    "data": {
                        "id": 10000,
                        "name": "cografi_bolgelere_gore_osb",
                        "service_id": 999,
                        "opacity": 0.8
                    },
                    "iconData": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABNJREFUCFtj/P//fwMDGmCkgSAAJM0Rd/6gspUAAAAASUVORK5CYII=",
                    "icon": "iconforsidebar_tematik_harita"
                },
                {
                    "key": "9999-10001",
                    "label": "Coğrafi Bölgelere Göre İstihdam Sayısı",
                    "data": {
                        "id": 10001,
                        "name": "c_bolgelere_gore_istihdam",
                        "service_id": 999,
                        "opacity": 0.8
                    },
                    "iconData": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABNJREFUCFtj/P//fwMDGmCkgSAAJM0Rd/6gspUAAAAASUVORK5CYII=",
                    "icon": "iconforsidebar_tematik_harita"
                },
                {
                    "key": "9999-10002",
                    "label": "Teşvik Bölgelerine Göre OSB Sayısı",
                    "data": {
                        "id": 10002,
                        "name": "t_bolgelere_gore_osb",
                        "service_id": 999,
                        "opacity": 0.8
                    },
                    "iconData": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABNJREFUCFtj/P//fwMDGmCkgSAAJM0Rd/6gspUAAAAASUVORK5CYII=",
                    "icon": "iconforsidebar_tematik_harita"
                },
                {
                    "key": "9999-10003",
                    "label": "Teşvik Bölgelerine Göre İstihdam Sayısı",
                    "data": {
                        "id": 10003,
                        "name": "t_bolgelere_gore_istihdam",
                        "service_id": 999,
                        "opacity": 0.8,
                    },
                    "iconData": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABNJREFUCFtj/P//fwMDGmCkgSAAJM0Rd/6gspUAAAAASUVORK5CYII=",
                    "icon": "iconforsidebar_tematik_harita"
                },
                {
                    "key": "9999-10004",
                    "label": "İBBS2 Göre OSB Sayısı",
                    "data": {
                        "id": 10004,
                        "name": "ibbs2_bolgelere_gore_osb",
                        "service_id": 999,
                        "opacity": 0.8
                    },
                    "iconData": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABNJREFUCFtj/P//fwMDGmCkgSAAJM0Rd/6gspUAAAAASUVORK5CYII=",
                    "icon": "iconforsidebar_tematik_harita"
                },
                {
                    "key": "9999-10005",
                    "label": "İBBS2 Göre İstihdam Sayısı",
                    "data": {
                        "id": 10005,
                        "name": "ibbs2_bolgelere_gore_istihdam",
                        "service_id": 999,
                        "opacity": 0.8
                    },
                    "iconData": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABNJREFUCFtj/P//fwMDGmCkgSAAJM0Rd/6gspUAAAAASUVORK5CYII=",
                    "icon": "iconforsidebar_tematik_harita"
                },
                {
                    "key": "9999-10006",
                    "label": "İllere Göre OSB Sayıları",
                    "data": {
                        "id": 10006,
                        "name": "illere_gore_osb",
                        "service_id": 999,
                        "opacity": 0.8

                    },
                    "iconData": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABNJREFUCFtj/P//fwMDGmCkgSAAJM0Rd/6gspUAAAAASUVORK5CYII=",
                    "icon": "iconforsidebar_tematik_harita"
                },
                {
                    "key": "9999-10007",
                    "label": "İllere Göre İstihdam Sayısı",
                    "data": {
                        "id": 10007,
                        "name": "illere_gore_istihdam",
                        "service_id": 999,
                        "opacity": 0.8
                    },
                    "iconData": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABNJREFUCFtj/P//fwMDGmCkgSAAJM0Rd/6gspUAAAAASUVORK5CYII=",
                    "icon": "iconforsidebar_tematik_harita"
                }
            ],
            data: null,
            key: 9999,
            label: "Tematik Haritalar"
        }

        return tematikHaritalar;
    }

    const onClickExport = async () => {
        const service = globalServices.find(obj => obj.id === selectedInternalLayer.service_id);
        if (service) {
            dispatch(setShowLoading(true));
            try {
                if (exportType === ExportTypes.KML) {
                    window.open(`${service.url}/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&typeName=${selectedInternalLayer.name}&outputFormat=application/vnd.google-earth.kml+xml`, '_blank')
                } else if (exportType === ExportTypes.SHAPEFILE) {
                    window.open(`${service.url}/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&typeName=${selectedInternalLayer.name}&outputFormat=SHAPE-ZIP`, '_blank')
                }
                window.open(`${process.env.REACT_APP_BASE_URL}/rest/v1/attachment/exportRelation/${selectedInternalLayer.id}?token=${token}`, '_blank')
                window.open(`${process.env.REACT_APP_BASE_URL}/rest/v1/attachment/export/${selectedInternalLayer.id}?token=${token}`, '_blank')
                const domains = selectedInternalLayer.fields.filter((obj: any) => obj.has_domain)
                for (const domain of domains) {
                    const options = domain.domain
                    let csv = 'id,description\n'
                    options.forEach(function (row: any) {
                        csv += Object.values(row).join(',');
                        csv += "\n";
                    });
                    const blob = new Blob([csv], { type: "text/csv" });
                    saveAs(blob, `${domain.alias}.csv`);

                }
                dispatch(setShowLoading(false));
                setExportOpened(false);
            } catch (error) {
                console.log(error);
                dispatch(setShowLoading(false));
                setExportOpened(false);
            }
        } else {
            setExportOpened(false);
        }

    }

    const onChangeSliderData = (value: any, layer: any) => {
        const cloneServices = []
        for (const service of globalServices) {
            const cloneService = { ...service, layers: [] }
            const cloneLayers = []
            for (const servicelayer of service.layers) {
                let cloneLayer;
                if (servicelayer.id === layer.id) {
                    cloneLayer = { ...servicelayer, opacity: (value as number) }
                } else {
                    cloneLayer = { ...servicelayer }
                }
                cloneLayers.push(cloneLayer);
            }
            (cloneService as any).layers = cloneLayers;
            cloneServices.push(cloneService);
        }
        dispatch(setServices(cloneServices));

        const cloneNodes = []
        for (const node of nodes) {
            const cloneNode = { ...node, children: [] }
            const cloneChildren = []
            for (const child of node.children) {
                let cloneChild;
                if (child.data.id === layer.id) {
                    cloneChild = { ...child, data: { ...child.data, opacity: (value as number) } }
                } else {
                    cloneChild = { ...child }
                }
                cloneChildren.push(cloneChild);
            }
            (cloneNode as any).children = cloneChildren;
            cloneNodes.push(cloneNode);
        }
        setNodes(cloneNodes);

    }
    const onChangeLabeling = (value: any, layer: any) => {
        const cloneServices = []
        for (const service of globalServices) {
            const cloneService = { ...service, layers: [] }
            const cloneLayers = []
            for (const servicelayer of service.layers) {
                let cloneLayer;
                if (servicelayer.id === layer.id) {
                    cloneLayer = { ...servicelayer, labeling: value }
                }
                else {
                    cloneLayer = { ...servicelayer }
                }
                cloneLayers.push(cloneLayer);
            }
            (cloneService as any).layers = cloneLayers;
            cloneServices.push(cloneService);

        }
        dispatch(setServices(cloneServices));
        const cloneNodes = []
        for (const node of nodes) {
            const cloneNode = { ...node, children: [] }
            const cloneChildren = []
            for (const child of node.children) {
                let cloneChild;
                if (child.data.id === layer.id) {
                    cloneChild = { ...child, data: { ...child.data, labeling: value } }
                } else {
                    cloneChild = { ...child, data: { ...child.data } }
                }
                cloneChildren.push(cloneChild);
            }
            (cloneNode as any).children = cloneChildren;
            cloneNodes.push(cloneNode);
        }
        setNodes(cloneNodes);
    }

    const onChangeHandler = (value: any, data: any) => {
        if (opacityTimeout) {
            clearTimeout(opacityTimeout);
        }
        const timeout = setTimeout(() => {
            onChangeSliderData(value, data);
        }, 100);
        setOpacityTimeout(timeout)
    }


    const nodeTemplate = (node: any, options: any) => {
        return (
            <div className={node.key === 69 || node.key === 9999   ? 'gizle' : ''}>
                <div >
                    {node.label}
                </div>
                {node.data &&
                    <div className='childss' style={{ display: 'flex', alignItems: 'center', paddingRight: '3em' }}>
                        <div className="tooltip">
                            <input type="range" min="0" max="1" value={node.data.opacity} step="0.05" className='custom-slider'
                                onChange={(e) => { onChangeHandler(e.target.value, node.data) }} />
                            <span className="tooltiptext">Şeffaflık</span>
                        </div>
                        {node.data && node.data.layer_group_id && (node.data.layer_group_id === 2 || node.data.layer_group_id === 72 || node.data.layer_group_id === 69 || node.data.layer_group_id === 66 || node.data.layer_group_id === 63) &&
                            <label style={{ display: 'flex' }} className="switch">
                                <span className="slider round"></span>
                                <div className="tooltip">
                                    <input type="checkbox" id='cb1' checked={node.data.labeling ? node.data.labeling : false} onChange={(e) => onChangeLabeling(node.data.labeling ? !node.data.labeling : true, node.data)} />
                                    <span className="tooltiptext">Etiket</span>
                                </div>
                            </label>}
                    </div>
                }
            </div>
        )
    }

    const selectedKeyHandler = (e: any) => {
        let keyValue = e.value
        //tematik haritalarda sadece 1 tane seçsinnnn
        const keys = Object.keys(keyValue).filter(key => key.includes('9999'))

        if (keys && keys.length > 2) {
            const keyValueArray: any = []
            const xx: any = []
            const selectedValueArray: any = []
            for (const [key, value] of Object.entries(keyValue) as any) {
                keyValueArray.push(key)
                xx.push({ key, value })
            }
            for (const [key, value] of Object.entries(selectedKey) as any) {
                selectedValueArray.push(key)
            }
            let intersection = keyValueArray.filter((x: any) => !selectedValueArray.includes(x));
            const eklemekIstedigim = xx.filter((x: any) => x.key === intersection[0])
            const digerleri = xx.filter((x: any) => x.key !== intersection[0]).filter((x: any) => !x.key.includes('9999-'));
            const newArray = [...eklemekIstedigim, ...digerleri]
            const result = newArray.reduce((a: any, v: any) => ({ ...a, [v.key]: v.value }), {})
            keyValue = result
            setSelectedKey(result);
        }
        else {
            setSelectedKey(keyValue);
        }

        //idari bölgelerde sadece 1 tane seçsinnnn
        const keys2 = Object.keys(keyValue).filter(key => key.includes('69'))
        if (keys2 && keys2.length > 2) {
            const keyValueArray: any = []
            const xx: any = []
            const selectedValueArray: any = []
            for (const [key, value] of Object.entries(keyValue) as any) {
                keyValueArray.push(key)
                xx.push({ key, value })
            }
            for (const [key, value] of Object.entries(selectedKey) as any) {
                selectedValueArray.push(key)
            }

            let intersection = keyValueArray.filter((x: any) => !selectedValueArray.includes(x));
            const eklemekIstedigim = xx.filter((x: any) => x.key === intersection[0])
            const digerleri = xx.filter((x: any) => x.key !== intersection[0]).filter((x: any) => !x.key.includes('69-'));
            const newArray = [...eklemekIstedigim, ...digerleri]
            const result = newArray.reduce((a: any, v: any) => ({ ...a, [v.key]: v.value }), {})
            setSelectedKey(result);
        }
        else {
            setSelectedKey(keyValue);
        }

    }


    return (
        <div className={`layers-container ${zindex ? 'index' : 'layers-container'} `}>
            <Button className={`layers-button ${layersOpened || zindex ? 'active' : ''}`} onClick={() => { setLayersOpened(!layersOpened) }} >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g id="layer" transform="translate(16344.2 6621.5)">
                        <path id="layers_FILL0_wght300_GRAD0_opsz24_3_" data-name="layers_FILL0_wght300_GRAD0_opsz24 (3)" d="M12,19.9,3.8,13.525,5.025,12.6,12,17.975,18.975,12.6l1.225.925Zm0-4.45L3.8,9.1,12,2.725,20.2,9.1ZM12,9.1Zm0,4.45L17.75,9.1,12,4.65,6.25,9.1Z" transform="translate(-16344.2 -6620.813)" fill="#fff" />
                        <rect id="Rectangle_141849" data-name="Rectangle 141849" width="24" height="24" transform="translate(-16344.2 -6621.5)" fill="none" />
                    </g>
                </svg>
            </Button>
            {
                (layersOpened || zindex) &&
                <div>
                    {/* {permission === 1 && <ContextMenu model={menu1} ref={cm} />} */}
                    <ContextMenu model={menu1} ref={cm} />
                    <ContextMenu model={menu2} ref={cm2} />
                    <ContextMenu model={menu3} ref={cm3} />
                    <Tree value={nodes} selectionMode="checkbox" nodeTemplate={nodeTemplate}
                        selectionKeys={selectedKey}
                        onSelectionChange={selectedKeyHandler}
                        onContextMenu={(event: any) => {

                            if (event.node.data) {
                                if (functionalRoles.findIndex((role: any) => role.function_id === 16) > -1 && functionalRoles.findIndex((role: any) => role.function_id === 15) === -1) {
                                    (cm as any).current?.show(event.originalEvent);
                                    (cm3 as any).current?.hide(event.originalEvent);
                                    (cm2 as any).current?.hide(event.originalEvent);
                                }
                                if (functionalRoles.findIndex((role: any) => role.function_id === 16) === -1 && functionalRoles.findIndex((role: any) => role.function_id === 15) > -1) {
                                    if (event.node.data.permission !== 1) {
                                        (cm2 as any).current?.show(event.originalEvent);
                                        (cm3 as any).current?.hide(event.originalEvent);
                                        (cm as any).current?.hide(event.originalEvent);
                                    }
                                    else {
                                        (cm as any).current?.show(event.originalEvent);
                                        (cm3 as any).current?.hide(event.originalEvent);
                                        (cm2 as any).current?.hide(event.originalEvent);
                                    }
                                }
                                if (functionalRoles.findIndex((role: any) => role.function_id === 16) > -1 && functionalRoles.findIndex((role: any) => role.function_id === 15) > -1) {
                                    if (event.node.data.permission !== 1) {
                                        (cm3 as any).current?.show(event.originalEvent);
                                        (cm2 as any).current?.hide(event.originalEvent);
                                        (cm as any).current?.hide(event.originalEvent);
                                    }
                                    else {
                                        (cm as any).current?.show(event.originalEvent);
                                        (cm3 as any).current?.hide(event.originalEvent);
                                        (cm2 as any).current?.hide(event.originalEvent);
                                    }
                                }
                                setSelectedInternalLayer(event.node.data);
                            }

                            globalServices.filter(service => service.type === 'VECTOR').map(service => service.layers.find(layer => layer.id === event.node.data?.id)) && globalServices.filter(service => service.type === 'VECTOR').map(service => service.layers.find(layer => layer.id === event.node.data?.id))[0] !== undefined ? setIsVectorLayer(true) : setIsVectorLayer(false)
                        }} />
                </div>
            }
            {
                <Dialog header="Dışa Aktar" style={{ minWidth: '30vw' }} visible={exportOpened} onHide={() => setExportOpened(false)}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div style={{ marginBottom: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                            <div>
                                <RadioButton value={ExportTypes.KML} onChange={(e) => setExportType(e.value)} checked={exportType === ExportTypes.KML} />
                                <label>Kml</label>
                            </div>
                            <div>
                                <RadioButton value={ExportTypes.SHAPEFILE} onChange={(e) => setExportType(e.value)} checked={exportType === ExportTypes.SHAPEFILE} />
                                <label>ShapeFile</label>
                            </div>
                        </div>
                        <Button onClick={() => onClickExport()} label="Dışa Aktar"></Button>
                    </div>
                </Dialog>
            }
        </div>
    )
}
